import { createFileRoute } from '@tanstack/react-router';
import { TransactionModelsPage } from '@/features/accounting/parameters/transaction-models/components/TransactionModelsPage';

export const Route = createFileRoute('/$commiteeSlug/accounting/parameters/transaction-models/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <TransactionModelsPage />;
}
